import { Message } from '@inshared/shared/core';
import { type } from '@inshared/shared/util';
import { Action } from '@ngrx/store';

export const ADD = type('[element] add');
export const ADD_SUCCESS = type('[element] add success');
export const ADD_ERROR = type('[element] add error');
export const SELECT = type('[element] select');

export class AddElement implements Action {
    readonly type = ADD;
    constructor(public payload: string) { }
}

export class AddElementSuccess implements Action {
    readonly type = ADD_SUCCESS;
    constructor(public payload: any) { }
}

export class AddElementError implements Action {
    readonly type = ADD_ERROR;
    constructor(public payload: { errors: Message[] }) { }
}

export type ElementsActions
    = AddElement
    | AddElementSuccess
    | AddElementError;
